import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        let dest = "/dashboard";
        try { const saved = localStorage.getItem("rl_post_login"); if (saved && saved.startsWith("/dashboard")) { dest = saved; localStorage.removeItem("rl_post_login"); } } catch { /* noop */ }
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true, state: { user: res.data } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand-50">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-redline-500 border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground font-body">Signing you in…</p>
      </div>
    </div>
  );
}
